import AddMaterialDialog from './AddMaterialDialog';
import Material from './Material';

export { AddMaterialDialog };
export default Material;
